import { DeliveryFeeSettings } from "../models/DeliveryFeeSettings"

export function calculateDeliveryFee(
  distanceInMiles: number,
  settings: DeliveryFeeSettings
): number {
  const extraMiles = Math.max(distanceInMiles - settings.includedMiles, 0)
  const extraHalfMiles = Math.ceil(extraMiles * 2)
  const costPerHalfMile =
    settings.costPerHalfMile ??
    (settings.costPerMile != null ? Math.round(settings.costPerMile / 2) : NaN)

  return settings.baseFee + extraHalfMiles * costPerHalfMile
}

export type FeeBand = {
  startMiles: number
  endMiles: number
  fee: number
}

export function getFeeBands(settings: DeliveryFeeSettings): FeeBand[] {
  const { includedMiles, maxMiles } = settings

  if (!Number.isFinite(includedMiles) || !Number.isFinite(maxMiles) || maxMiles <= 0) {
    return []
  }

  const bandStarts: number[] = [0]

  for (let boundary = includedMiles; boundary < maxMiles - 1e-9; boundary += 0.5) {
    if (boundary > 0) {
      bandStarts.push(boundary)
    }
  }

  const bands: FeeBand[] = []

  for (let i = 0; i < bandStarts.length; i++) {
    const startMiles = bandStarts[i]
    const endMiles = i + 1 < bandStarts.length ? bandStarts[i + 1] : maxMiles

    bands.push({
      startMiles,
      endMiles,
      fee: calculateDeliveryFee(endMiles, settings),
    })
  }

  return bands
}
